'use strict';

export default function galleryList() {
  return [
    {
      name: 'fresh',
      slug: 'fresh',
      desc: 'New cinemagraphs, hot off the press! The top living photos created by the Flixel Community, featured daily.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/fresh.png',
    }, {
      name: 'advertising',
      slug: 'advertising',
      desc: 'Cinemagraphs are great for capturing attention in digital advertising. Check out some examples in the Flixel gallery!',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/advertising.png',
    }, {
      name: 'aerial',
      slug: 'aerial',
      desc: 'Ever heard of a drone cinemagraph? Check out the best aerial cinemagraphs from across the globe.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/aerial.png',
    }, {
      name: 'antm',
      slug: 'antm',
      desc: 'Cinemagraphs created on Cycle 20 of America\'s Next Top Model with Flixel Studios.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/antm.png',
    }, {
      name: 'animals',
      slug: 'animals',
      desc: 'Fuzzy, feathery, fluffy... check out these adorable animal cinemagraphs in the Flixel gallery!',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/animals.png',
    }, {
      name: 'arts',
      slug: 'arts',
      desc: 'Create art to celebrate the arts. Head over to the Flixel gallery to check out these painting, dancing, and music cinemagraphs.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/arts.png',
    }, {
      name: 'automotive',
      slug: 'automotive',
      desc: 'These car cinemagraphs will make you want to hit the brakes on still photos.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/automotive.png',
    }, {
      name: 'black and white',
      slug: 'black-and-white',
      desc: 'Experience the beauty of the moment in these black-and-white cinemagraphs.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/black-white.png',
    }, {
      name: 'beauty',
      slug: 'beauty',
      desc: 'Flowing hair, spray of perfume, blinking eyes: tell a different story with beauty cinemagraphs.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/beauty.png',
    }, {
      name: 'cityscapes',
      slug: 'cityscapes',
      desc: 'Gain a new perspective of the skyline from these cityscape cinemagraphs created with Flixel Cinemagraph Pro.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/cityscapes.png',
    }, {
      name: 'creative fx',
      slug: 'creative-fx',
      desc: 'Check out these examples of cinemagraphs created by combining Adobe and Flixel together.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/creative-fx.png',
    }, {
      name: 'facebook profiles',
      slug: 'facebook-profiles',
      desc: 'Get inspired by these Facebook Profile cinemagraphs and create your own using Cinemagraph Pro for free! ',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/facebook-profiles.png',
    }, {
      name: 'fashion',
      slug: 'fashion',
      desc: 'Strike a pose, and bring it to life like these fashion cinemagraphs.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/fashion.png',
    }, {
      name: 'featured artists',
      slug: 'featured-artist',
      desc: 'Cinemagraphs created by top photographers and Flixel Wizards from around the world.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/featured-artists.png',
    }, {
      name: 'festive',
      slug: 'festive',
      desc: 'See how you can preserve memories of holidays, birthdays, and celebrations using cinemagraphs.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/festive.png',
    }, {
      name: 'flixel flag',
      slug: 'flixel-flag',
      desc: 'Check out cinemagraphs created by Flixel Artists from around the world featuring the official Flixel flag.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/flixel-flag.png',
    }, {
      name: 'fireworks',
      slug: 'fireworks',
      desc: 'Be mesmerized by the big finish of a fireworks display endlessly as a cinemagraph.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/fireworks.png',
    }, {
      name: 'food',
      slug: 'food',
      desc: 'Satisfy your cravings with these delicious food cinemagraphs created with Flixel tools.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/food.png',
    }, {
      name: 'jewelry',
      slug: 'jewelry',
      desc: 'See how you can shine bright like a diamond by using jewelry cinemagraphs for your next marketing campaign.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/jewelry.png',
    }, {
      name: 'landscape',
      slug: 'landscape',
      desc: 'Get inspired by views from around the world captured in landscape cinemagraphs.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/landscape.png',
    }, {
      name: 'lifestyle',
      slug: 'lifestyle',
      desc: 'Celebrate your world by creating inspiring lifestyle cinemagraphs with Cinemagraph Pro.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/lifestyle.png',
    }, {
      name: 'long exposure',
      slug: 'long-exposure',
      desc: 'Celebrate your world by creating inspiring long exposure cinemagraphs with Cinemagraph Pro.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/long-exposure.png',
    }, {
      name: 'nature',
      slug: 'nature',
      desc: 'Capture the world\'s hidden treasures in a stunning nature cinemagraph.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/nature.png',
    }, {
      name: 'photobooth',
      slug: 'photobooth',
      desc: 'Make your events more engaging and memorable with a custom Flixel cinemagraph booth experience.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/photobooth.png',
    }, {
      name: 'people',
      slug: 'people',
      desc: 'People are great subjects in cinemagraphs. Use living photos to celebrate the little details of the human experience.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/people.png',
    }, {
      name: 'portrait',
      slug: 'portrait',
      desc: 'Get up close and personal in this series of beautiful portrait cinemagraphs created with Flixel tools.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/portrait.png',
    }, {
      name: 'real estate',
      slug: 'real-estate',
      desc: 'Change your real estate marketing strategies by using cinemagraphs to show off the hottest properties.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/real-estate.png',
    }, {
      name: 'screens',
      slug: 'screens',
      desc: 'Use computer, camera, and digital displays in your cinemagraphs created with Flixel Cinemagraph Pro.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/screens.png',
    }, {
      name: 'screensaver',
      slug: 'screensaver',
      desc: 'Cinemagraphs created by the Flixel community selected for you. Download the Flixel Screensaver for macOS today.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/screensaver.png',
    }, {
      name: 'space',
      slug: 'space',
      desc: 'Experience infinity and beyond through space cinemagraphs that are out of this world.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/space.png',
    }, {
      name: 'sport',
      slug: 'sport',
      desc: 'Whether skiing, basketball, cycling, or fitness, sport cinemagraphs are always changing the game.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/sports.png',
    }, {
      name: 'street',
      slug: 'street',
      desc: 'Change the way you think of urban photography through street cinemagraphs of London, Lisbon, New York, and more. ',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/street.png',
    }, {
      name: 'things',
      slug: 'things',
      desc: 'A gallery of cinemagraphs that use objects, equipment, and things, created with Flixel tools. ',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/things.png',
    }, {
      name: 'timelapse',
      slug: 'timelapse',
      desc: 'Freeze and speed life up at exact the same time. Combine time lapses with your cinemagraphs for a mesmerizing effect.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/timelapse.png',
    }, {
      name: 'transport',
      slug: 'transport',
      desc: 'See how living photos make your stories take flight in these transport cinemagraphs.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/transport.png',
    }, {
      name: 'travel',
      slug: 'travel',
      desc: 'Explore the world through these travel cinemagraphs created with Flixel Cinemagraph Pro.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/travel.png',
    }, {
      name: 'vertical',
      slug: 'vertical',
      desc: 'Vertical video is taking over social media. Get inspired by this gallery of vertical cinemagraphs and create your own using Flixel Cinemagraph Pro.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/vertical.png',
    }, {
      name: 'water',
      slug: 'water',
      desc: 'Capture the beautiful, real motions of water and create nature cinemagraphs in Cinemagraph Pro.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/water.png',
    }, {
      name: 'wedding',
      slug: 'wedding',
      desc: 'Make the memories of a client\'s special day live forever in wedding cinemagraphs.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/wedding.png',
    }, {
      name: 'workplace',
      slug: 'workplace',
      desc: 'Offices, laboratories, storefronts, and beyond. Share what makes your workplace a great place with cinemagraphs.',
      image: 'https://cdn.flixel.com/static/gallery-covers-web/workplace.png',
    },
  ];
}



// WEBPACK FOOTER //
// ./src/services/galleryList.es6.js